import React, { useEffect, useState } from 'react';
import { useOktaAuth } from '@okta/okta-react';

import OktaErrorHandler from './OktaErrorHandler';

const CustomLoginCallback = ({ onAuthResume }: { onAuthResume?: () => void }) => {
  const { authState, oktaAuth } = useOktaAuth();
  const [callbackError, setCallbackError] = useState(null);
  const authStateReady = !!authState;
  useEffect(() => {
    if (onAuthResume && oktaAuth.isInteractionRequired?.() ) {
      onAuthResume();
      return;
    }
    oktaAuth.handleLoginRedirect().then().catch((e: Error) => {
      setCallbackError(e);
    });
  }, [oktaAuth, onAuthResume]);

  const authError = authStateReady ? authState.error : null;
  const displayError = callbackError || authError;
  if (displayError) {
    return <OktaErrorHandler oktaAuth={oktaAuth} error={displayError}/>;
  }

  return null;
};

export default CustomLoginCallback;
